export default (theme) => ({
  paymentUpdateForm: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 40,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  paymentWrapper: {
    width: '100%',
    minWidth: 'initial',
    maxWidth: 590,
    marginTop: -25,
    '& > div': {
      marginTop: 0,
    },
  },
  defaultCard: {
    fontSize: 14,
    width: '100%',
  },
  errorTextCard: {
    fontSize: 14,
    color: theme.palette.error.main,
    marginTop: -10,
    marginBottom: 10,
  },
  parentCheckbox: {
    display: 'flex',
    flexDirection: 'column',
  },
});
